import { Email } from 'types/Email';
import { Maybe, MaybeUndef } from 'types/UtilityTypes';
import { EmailLabels } from 'types/enums/EmailLabels';

/**
 * True when Drumkit `labels` include {@link EmailLabels.QuoteRequest}.
 * Expects comma-separated tokens as produced by the API (`strings.Join` of `EmailLabel` values); each segment is trimmed only.
 */
export function emailLabelsIncludeQuoteRequest(
  labels: MaybeUndef<string>
): boolean {
  if (labels == null || labels.trim() === '') {
    return false;
  }

  return labels
    .split(',')
    .some((part) => part.trim() === EmailLabels.QuoteRequest);
}

/** True when the API populated {@link Email.detectedBiddingPortal} for bidding-portal notification mail. */
export function emailHasDetectedBiddingPortal(email: Maybe<Email>): boolean {
  return Boolean(email?.detectedBiddingPortal?.trim());
}

// Auto-bid-eligible detection defaults to Submit Bid. Empty detection and
// attribution-only mail (biddingPortalAutoBidEligible === false) default to
// Draft Email so the rep opts in manually.
export function shouldDefaultToSubmitBidFlow(email: Maybe<Email>): boolean {
  return (
    emailHasDetectedBiddingPortal(email) &&
    email?.biddingPortalAutoBidEligible !== false
  );
}

// Submit-bid UI may be offered when the thread is a quote request.
// Detection and auto-bid eligibility only affect default tab via
// shouldDefaultToSubmitBidFlow. Credentials / feature / mode gates stay in
// QuickQuoteForm.
export function isSubmitBidThreadEligible(email: Maybe<Email>): boolean {
  if (email == null) {
    return false;
  }

  return emailLabelsIncludeQuoteRequest(email.labels);
}
